<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUpdate, ref } from 'vue'
import { GetImg, SqlManipulate } from '../../method/Post';
import ls from '../../method/localStorage';
import { floatTimes, NumberCut } from '../../method/floatCalculate';
import { ElMessageBox } from 'element-plus';
let prop = defineProps<{
    id: number;
    langPack: Map<string, string>;
    lang: string,
    orientation: string
}>()

let modelValue = ref({
    Oid: 0,
    Item_CN: "",
    Item_ES: "",
    Item_EN: "",
    AuxTaxPrice_Weight: 0,
    WeightUnitName: "$",
    Char_2: "",
    PWeight: 0,
    LWeight: 0,
    Volume: 0,
    IMG_1: "",
    Char_MS_CN: "",
    Char_MS_EN: "",
    Char_MS_ES: "",
    QtyPiece: 0,
    AuxQty: 1
});
let AuxQty = computed(() => {
    return floatTimes(QtyPiece.value, modelValue.value.PWeight)
})
let QtyPiece = ref(0);
onBeforeMount(() => {
    GetDetail();
})
onBeforeUpdate(()=>{
    if(prop.id != modelValue.value.Oid){
        GetDetail()
    }
})

let imageList = ref(new Array<any>());
let previewList = ref(new Array<string>())

const GetDetail = () => {
    SqlManipulate("Web_GetDetail", { Oid: ref(prop.id).value, TCustId: ls.get("CustId") }, (res: any) => {
        modelValue.value = res
        modelValue.value["QtyPiece"] = 0
        modelValue.value["AuxQty"] = 0
        GetImageList()
    })
}

const GetImageList = () => {
    previewList.value=[];
    imageList.value=[];
    let keys = Reflect.ownKeys(modelValue.value);
    keys.forEach(key => {
        if (key.toString().startsWith('IMG_')) {
            let value = Reflect.get(modelValue.value, key)
            console.log(value)
            if (value != undefined && value != "") {
                GetImg(value, (result: string) => {
                    previewList.value.push(result)
                })
                if (value.startsWith('/upload/')) {
                    let lastdotIndex = value.lastIndexOf('.');
                    let pre = value.substring(0, lastdotIndex);
                    let extname = value.substring(lastdotIndex, value.length);
                    let url_server_s = pre + "_s" + extname;
                    GetImg(url_server_s, (result: string) => {
                        imageList.value.push(result)
                    })
                }
            }
        }
    })
}

const handleAddCart = () => {
    SqlManipulate("Web_AddCart", { TCustId: ls.get("CustId"), Oid: modelValue.value.Oid, QtyPiece: QtyPiece.value, AuxQty: AuxQty.value }, (res: any) => {
        console.log(res)
        ElMessageBox.alert(ref(prop.langPack).value.get("SubmitSuccess"), ref(prop.langPack).value.get("Success"), {
            confirmButtonText: ref(prop.langPack).value.get("confirm")
        })
    })
}

</script>
<template>
    <el-card class="card" v-if="orientation == 'horizontal'">
        <el-row>
            <el-col :span="8">
                <div>
                    <el-carousel type="card" height="30rem" :autoplay="false">
                        <el-carousel-item v-for="item in imageList" :key="item">
                            <el-image style="width:100%;height: 100%;" :src="item" fit="contain"
                                :preview-teleported="true" :preview-src-list="previewList" hide-on-click-modal />
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </el-col>
            <el-col :span="16">
                <div class="mainInfo">
                    <text class="detailtitle" v-if="lang == '简体中文'">{{ modelValue.Item_CN }}</text>
                    <text class="detailtitle" v-if="lang == 'Español'">{{ modelValue.Item_ES }}</text>
                    <text class="detailtitle" v-if="lang == 'English'">{{ modelValue.Item_EN }}</text>
                    <text class="detailtitle" v-if="lang == 'Português'">{{ modelValue.Item_ES }}</text>
                    <div>
                        <text class="detailPrice">{{ langPack.get("Price") }}:</text>
                        <text class="detailPrice">{{ NumberCut(modelValue.AuxTaxPrice_Weight.toString()) }}</text>
                        <text class="detailPrice">{{ langPack.get("unit") }}:</text>
                        <text class="detailPrice">{{ modelValue.WeightUnitName }}</text>
                    </div>
                    <div class="detailtext">
                        <text>{{ langPack.get("huohao") }}:</text>
                        <text style="margin-left: 10px;">{{ modelValue.Char_2 }}</text>
                    </div>
                    <div class="detailtext">
                        <text>{{ langPack.get("PWeight") }}:</text>
                        <text style="margin-left: 10px;">{{ NumberCut(modelValue.PWeight.toString()) }}</text>
                    </div>
                    <div class="detailtext">
                        <text>{{ langPack.get("Volume") }}:</text>
                        <text style="margin-left: 10px;">{{ NumberCut(modelValue.Volume.toString()) }}</text>
                    </div>
                    <div class="detailtext">
                        <text>{{ langPack.get("LWeight") }}:</text>
                        <text style="margin-left: 10px;">{{ NumberCut(modelValue.LWeight.toString()) }}</text>
                    </div>
                    <div class="detailtext">
                        <text>{{ langPack.get("QtyPiece") }}:</text>
                        <el-input-number v-model="QtyPiece" :min="modelValue.QtyPiece" step-strictly :step="1"
                            style="margin-left: 10px" />
                        <text class="warningtext" v-if="QtyPiece == modelValue.QtyPiece && modelValue.QtyPiece != 0">*{{
                            langPack.get("LWeightis") }}{{ modelValue.QtyPiece }}</text>
                    </div>
                    <div class="detailtext">
                        <text>{{ langPack.get("AuxQty") }}:</text>
                        <el-input-number v-model="AuxQty" :min="modelValue.AuxQty" step-strictly :step="1"
                            v-if="QtyPiece == 0" style="margin-left: 10px" />
                        <text style="margin-left: 10px;" v-if="QtyPiece != 0">{{ AuxQty }}</text>
                        <text class="warningtext"
                            v-if="AuxQty == modelValue.AuxQty && modelValue.AuxQty != 0 && modelValue.QtyPiece == 0">*{{
                                langPack.get("LWeightis") }}{{ Number.parseInt(modelValue.AuxQty.toString()) }}</text>
                    </div>
                    <div class="detailbutton">
                        <!-- <el-button type="primary" @click="handleSubmit">{{ langPack.get("SubmitOrder") }}</el-button> -->
                        <el-button type="warning" @click="handleAddCart">{{ langPack.get("AddCart") }}</el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <text v-if="lang == '简体中文'">{{ modelValue.Char_MS_CN }}</text>
            <text v-if="lang == 'Español'">{{ modelValue.Char_MS_ES }}</text>
            <text v-if="lang == 'English'">{{ modelValue.Char_MS_EN }}</text>
            <text v-if="lang == 'Português'">{{ modelValue.Char_MS_ES }}</text>
        </el-row>
    </el-card>

    <div v-if="orientation == 'vertical'">
        <div>
            <el-carousel height="260px">
                <el-carousel-item v-for="item in imageList" :key="item">
                    <el-image style="width:100%;height: 100%;" :src="item" fit="contain" :preview-teleported="true"
                        :preview-src-list="previewList" hide-on-click-modal />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="mainInfo">
            <text class="detailtitle-vertical" v-if="lang == '简体中文'">{{ modelValue.Item_CN }}</text>
            <text class="detailtitle-vertical" v-if="lang == 'Español'">{{ modelValue.Item_ES }}</text>
            <text class="detailtitle-vertical" v-if="lang == 'English'">{{ modelValue.Item_EN }}</text>
            <text class="detailtitle-vertical" v-if="lang == 'Português'">{{ modelValue.Item_ES }}</text>
            <text class="detailtext-vertical" v-if="lang == '简体中文'">{{ modelValue.Char_MS_CN }}</text>
            <text class="detailtext-vertical" v-if="lang == 'Español'">{{ modelValue.Char_MS_ES }}</text>
            <text class="detailtext-vertical" v-if="lang == 'English'">{{ modelValue.Char_MS_EN }}</text>
            <text class="detailtext-vertical" v-if="lang == 'Português'">{{ modelValue.Char_MS_ES }}</text>
            <div>
                <text class="detailPrice-vertical">{{ langPack.get("Price") }}:</text>
                <text class="detailPrice-vertical">{{ NumberCut(modelValue.AuxTaxPrice_Weight.toString()) }}</text>
                <text class="detailPrice-vertical">{{ langPack.get("unit") }}:</text>
                <text class="detailPrice-vertical">{{ modelValue.WeightUnitName }}</text>
            </div>
            <div>
                <text class="detailtext-vertical">{{ langPack.get("huohao") }}:</text>
                <text class="detailtext-vertical">{{ modelValue.Char_2 }}</text>
                <text class="detailtext-vertical">{{ langPack.get("PWeight") }}:</text>
                <text class="detailtext-vertical">{{ NumberCut(modelValue.PWeight.toString()) }}</text>
            </div>
            <div>
                <text class="detailtext-vertical">{{ langPack.get("Volume") }}:</text>
                <text class="detailtext-vertical">{{ NumberCut(modelValue.Volume.toString()) }}</text>
                <text class="detailtext-vertical">{{ langPack.get("LWeight") }}:</text>
                <text class="detailtext-vertical">{{ NumberCut(modelValue.LWeight.toString()) }}</text>
            </div>
            <div style="margin-top: 10px;">
                <text class="detailtext-vertical">{{ langPack.get("QtyPiece") }}:</text>
                <el-input-number v-model="QtyPiece" :min="modelValue.QtyPiece" step-strictly :step="1"
                    style="margin-left: 10px" />
                <text class="warningtext" v-if="QtyPiece == modelValue.QtyPiece && modelValue.QtyPiece != 0">*{{
                    langPack.get("LWeightis") }}{{ modelValue.QtyPiece }}</text>
            </div>
            <div style="margin-top: 10px;">
                <text class="detailtext-vertical">{{ langPack.get("AuxQty") }}:</text>
                <el-input-number v-model="AuxQty" :min="modelValue.AuxQty" step-strictly :step="1" v-if="QtyPiece == 0"
                    style="margin-left: 10px" />
                <text class="detailtext-vertical" v-if="QtyPiece != 0">{{ AuxQty }}</text>
                <text class="warningtext-vertical"
                    v-if="AuxQty == modelValue.AuxQty && modelValue.AuxQty != 0 && modelValue.QtyPiece == 0">*{{
                        langPack.get("LWeightis") }}{{ Number.parseInt(modelValue.AuxQty.toString()) }}</text>
            </div>
            <div class="detailbutton-vertical">
                <el-button type="warning" @click="handleAddCart">{{ langPack.get("AddCart") }}</el-button>
            </div>
        </div>
    </div>
</template>
<style scoped>
.mainInfo {
    display: flex;
    flex-direction: column;
    margin-left: 0;
    text-align: left;
}

.detailtitle {
    margin-left: 16px;
    font-size: 30px;
    color: #333333;
}
.detailtitle-vertical {
    margin-left: 10px;
    font-size: 24px;
    color: #333333;
}

.detailPrice {
    margin-left: 16px;
    font-size: 30px;
    color: #409EFF
}

.detailPrice-vertical {
    margin-left: 10px;
    font-size: 16px;
    color: #409EFF
}

.detailtext {
    margin-left: 16px;
    font-size: 14px;
    color: #333333;
    margin-top: 10px;
    margin-bottom: 10px;
}

.detailtext-vertical {
    margin-left: 10px;
    font-size: 16px;
}

.warningtext {
    color: red;
    font-size: 0.6rem;
}
.warningtext-vertical {
    color: red;
    font-size:14px;
}

.detailbutton {
    margin-left: 16px;
}
.detailbutton-vertical {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
</style>